import { Pressable, StyleSheet, View } from 'react-native';
import { Camera, FileText, PenLine } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import type { AssistantMode } from '../../types/aiAssistant';
import { AppText } from '../ui/AppText';

type AssistantModeBarProps = {
  activeMode: AssistantMode;
  onChangeMode: (mode: AssistantMode) => void;
};

const modes: Array<{ id: AssistantMode; label: string; Icon: typeof Camera }> = [
  { id: 'explain', label: '讲题', Icon: Camera },
  { id: 'correct', label: '批改', Icon: PenLine },
  { id: 'paper', label: '试卷', Icon: FileText },
];

export function AssistantModeBar({ activeMode, onChangeMode }: AssistantModeBarProps) {
  return (
    <View style={styles.wrapper}>
      {modes.map(({ id, label, Icon }) => {
        const active = activeMode === id;
        return (
          <Pressable
            key={id}
            accessibilityRole="button"
            onPress={() => onChangeMode(id)}
            style={({ pressed }) => [
              styles.modeButton,
              active ? styles.modeButtonActive : null,
              pressed ? styles.pressed : null,
            ]}
          >
            <Icon size={16} color={active ? tokens.colors.white : tokens.colors.primary} />
            <AppText
              variant="caption"
              weight="bold"
              style={active ? styles.activeLabel : null}
              tone={active ? 'default' : 'primary'}
            >
              {label}
            </AppText>
          </Pressable>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    gap: tokens.spacing.sm,
  },
  modeButton: {
    flex: 1,
    minHeight: 42,
    borderRadius: tokens.radius.full,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacing.xs,
    backgroundColor: tokens.colors.surfaceMuted,
  },
  modeButtonActive: {
    backgroundColor: tokens.colors.primary,
  },
  activeLabel: {
    color: tokens.colors.white,
  },
  pressed: {
    opacity: 0.86,
  },
});
